import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/clock-in-templates')({
    component: ClockInTemplatesRedirect,
});

// Clock reminder templates now live on the Clock in / Clock out page.
function ClockInTemplatesRedirect() {
    return <Navigate to="/settings/clock-in-out" replace={true} />;
}
